import * as marietta from '../..';

class MeasureInfoCollection {
        index: number;

        point1: marietta.core.Point;

        point2: marietta.core.Point;

        point3: marietta.core.Point;
}
export default MeasureInfoCollection;
